// Subtract two human-readable decimal strings with enough precision for display/copy.
// Using BigInt arithmetic on scaled integers avoids float precision loss.
export function subtractDecimalStrings(a: string, b: string): string {
  if (!/^-?[0-9]*\.?[0-9]+$/.test(a) || !/^-?[0-9]*\.?[0-9]+$/.test(b)) {
    throw new Error(
      `subtractDecimalStrings: inputs must be standard decimal strings, got "${a}" and "${b}"`,
    );
  }
  const decimalsA = a.includes(".") ? a.split(".")[1].length : 0;
  const decimalsB = b.includes(".") ? b.split(".")[1].length : 0;
  const scale = Math.max(decimalsA, decimalsB);
  const bigA = BigInt(
    a
      .replace(".", "")
      .padEnd(a.replace(".", "").length + scale - decimalsA, "0"),
  );
  const bigB = BigInt(
    b
      .replace(".", "")
      .padEnd(b.replace(".", "").length + scale - decimalsB, "0"),
  );
  const diff = bigA - bigB;
  if (scale === 0) return diff.toString();
  const raw = diff.toString().replace("-", "");
  const sign = diff < 0n ? "-" : "";
  const padded = raw.padStart(scale + 1, "0");
  const intPart = padded.slice(0, padded.length - scale) || "0";
  const fracPart = padded.slice(padded.length - scale).replace(/0+$/, "");
  return sign + (fracPart ? `${intPart}.${fracPart}` : intPart);
}
